import { render, staticRenderFns } from "./ApplyTempAccount.vue?vue&type=template&id=38ad38b0&scoped=true"
import script from "./ApplyTempAccount.vue?vue&type=script&lang=js"
export * from "./ApplyTempAccount.vue?vue&type=script&lang=js"
import style0 from "./ApplyTempAccount.vue?vue&type=style&index=0&id=38ad38b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38ad38b0",
  null
  
)

export default component.exports